import { lazy, Suspense, useCallback, useEffect, useMemo, useState } from 'react'
import { ApiEndpoints } from '../../helper/ApiEndpoints';
import { useNavigate, useParams } from 'react-router-dom';
import ApiRequest from '../../helper/ApiRequest';
import CloneAppBanner from './CloneAppBanner';
import CloneAppService from './CloneAppService';

const LyftDisclaimer = lazy(() => import('./LyftDisclaimer'));
const CloneAppSliderApp = lazy(() => import('./CloneAppSliderApp'));
const CloneAppSuccess = lazy(() => import('./CloneAppSuccess'));
const CloneAppShift = lazy(() => import('./CloneAppShift'));
const CloneAppWheel = lazy(() => import('./CloneAppWheel'));
const CloneAppFaq = lazy(() => import('./CloneAppFaq'));

const cloneAppListEndpoint = ApiEndpoints.CloneApp.cloneAppView;
export default function CloneAppsDynamic() {
  const navigate = useNavigate();
  const { cloneapp_url } = useParams();
  const [loading, setLoading] = useState(true);

  const [sections, setSections] = useState({
    section1: {},
    section2: {},
    section3: {},
    section4: {},
    section5: {},
    section6: {},
    section7: {}
  });

  const navigateTo404 = useCallback(() => {
    navigate("404");
  }, [navigate]);

  const dataFetch = useCallback(async () => {
    try {
      setLoading(true)
      const response = await ApiRequest("GET", cloneAppListEndpoint);
      const result = response.data;
      const matchingData = result.find((item) => item.url === cloneapp_url);

      if (matchingData) {
        const { section1, section2, section3, section4, section5, section6, section7 } = matchingData.sections || {};
        setSections({
          section1: section1?.[0] || {},
          section2: section2?.[0] || {},
          section3: section3 || {},
          section4: section4?.[0] || {},
          section5: section5?.[0] || {},
          section6: section6?.[0] || {},
          section7: section7 || {}
        });
      } else {
        navigateTo404();
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false)
    }
  }, [cloneapp_url, navigateTo404]);

  useEffect(() => {
    dataFetch();
  }, [dataFetch]);

  // Memoize the sections to prevent unnecessary renders
  const memoizedSections = useMemo(() => sections, [sections]);

  if (loading) {
    return <div style={{ width: "100%", height: "150vh" }}>loading..</div>
  }
  return (
    <>
      <CloneAppBanner section1={memoizedSections.section1} />
      <CloneAppService section2={memoizedSections.section2} />

      <Suspense fallback={null}>
        <CloneAppSliderApp section3={memoizedSections.section3} />
        <CloneAppSuccess section4={memoizedSections.section4} />
        <CloneAppShift section5={memoizedSections.section5} />
        <CloneAppWheel section6={memoizedSections.section6} />
        <CloneAppFaq section7={memoizedSections.section7} />
        <LyftDisclaimer />
      </Suspense>
    </>
  )
}
